// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oCHE6","name":"styles_name__32B0o","phone":"styles_phone__3u5Ng"};